import { render } from "./AddEditSpecificModal.vue?vue&type=template&id=1f5c7286&scoped=true"
import script from "./AddEditSpecificModal.vue?vue&type=script&lang=js"
export * from "./AddEditSpecificModal.vue?vue&type=script&lang=js"

import "./AddEditSpecificModal.vue?vue&type=style&index=0&id=1f5c7286&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5c7286"]])

export default __exports__